import generateId from '../../utils/generateId';
import dotProp from 'dot-prop-immutable';

export default (state, action) => {
  const { type, textNodeIndex, conditionNodeIndex, payload } = action;

  let textNode = state[textNodeIndex] || {};
  let _conditions = [].concat(textNode.conditions);

  switch (type) {
    case 'addText':
      return [
        ...state,
        {
          ...payload,
          conditions: [{ _id: generateId() }],
          _id: generateId()
        }
      ];
    case 'updateText':
      return dotProp.set(state, textNodeIndex, {
        ...state[textNodeIndex],
        ...payload
      });
    case 'removeText':
      return state.filter(({ _id }) => _id !== payload.id);
    case 'addCondition':
      _conditions.push({ _id: generateId() });

      return dotProp.set(state, textNodeIndex, {
        ...state[textNodeIndex],
        conditions: _conditions
      });
    case 'updateCondition':
      _conditions[conditionNodeIndex] = {
        ..._conditions[conditionNodeIndex],
        ...payload
      };

      return dotProp.set(state, textNodeIndex, {
        ...state[textNodeIndex],
        conditions: _conditions
      });
    case 'removeCondition':
      _conditions.splice(conditionNodeIndex, 1);

      return dotProp.set(state, textNodeIndex, {
        ...state[textNodeIndex],
        conditions: _conditions
      });
    case 'load':
      return payload.map(desc => ({
        ...desc,
        conditions: desc.conditions.map(c => ({ ...c, _id: generateId() }))
        // _id: generateId()
      }));
    default:
      return state;
  }
};
